import {CtModelRouteData} from "@ctsolution/ct-framework";

export const ContactPlaceRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("contactplace");
